import {useTranslation} from "react-i18next";

const AffiliateCommission = () => {


    const {t} = useTranslation()

    return (
        <div
            className="tab-pane fade show active"
            id="tab-1"
            role="tabpanel"
            aria-labelledby="1-tab"
            tabIndex={0}
        >

            <div className="row">
                <div className="article col-12">
                    <h6> {t('affiliate.commission.h1')}</h6>
                    <p className="">{t('affiliate.commission.d1')}</p>

                    <p className="formula">{t('affiliate.commission.f1')}</p>


                    <br/>


                    <h6> {t('affiliate.commission.h2')}</h6>
                    <p className="">{t('affiliate.commission.d2')}</p>

                    <p className="formula">{t('affiliate.commission.f2')}</p>

                </div>
            </div>

        </div>


    )

}


export default AffiliateCommission
